import script from "./OverlayControl.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayControl.vue?vue&type=script&setup=true&lang=js"

import "./OverlayControl.vue?vue&type=style&index=0&id=9b7dce04&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b7dce04"]])

export default __exports__